import React from "react";
import * as THREE from 'three'
import { KeyboardControls } from "@react-three/drei";
import { useShallow } from 'zustand/react/shallow'

import Fox from './Fox';
import Rabbit from './Rabbit';
//import useAnimalPerspective from "../hooks/useAnimalPerspective";
import SelectPlayerButton from './SelectPlayerButton';
import GameOverText from './GameOverText';
import AnimalPerspective from './AnimalPerspective';
import SkyBox from 'lib/misc/SkyBox';
import Ground from 'lib/misc/Ground'
import BaseCanvas from 'bundles/Cone/components/BaseCanvas';
import { useAppStore } from 'startup/appStore'
import InfoBox from 'lib/misc/InfoBox';

export default function FoxGame(props) {

    //useAnimalPerspective();

    const { 
        gameStatus,
    } = useAppStore( useShallow((state) => ({
        gameStatus: state.gameStatus,
    })));

    return (
        <>
            <BaseCanvas
                frameloop={['start', 'ending'].indexOf(gameStatus) > -1 ? "always" : "demand"}
                position={[0, 8, 0]}
                minPolarAngle={1.3}
                maxPolarAngle={1.5}
                minDistance={10}
                maxDistance={20}
            >
                <SelectPlayerButton player={'fox'} position={[-3,1.5,0]} />
                <SelectPlayerButton player={'rabbit'} position={[3,1.5,0]} />
                <GameOverText position={[0,2,0]} />

                <KeyboardControls map={[
                    { keys: ["k", "ArrowUp"], name: "moveForward" },
                    { keys: ["j", "ArrowDown"], name: "moveBackward" },
                    { keys: ["l", "ArrowLeft"], name: "moveLeft" },
                    { keys: ["h", "ArrowRight"], name: "moveRight" },
                    { keys: ["Space"], name: "jump" }
                ]}>
                    <Rabbit />
                    <Fox />
                </KeyboardControls>
                <AnimalPerspective />
                <SkyBox />;
                <Ground
                    //texturePath='/textures/moos.jpg'
                    texturePath='/monster/imgs/dirt-cracked.png'
                    repeat={5}
                />
            </BaseCanvas>
            <InfoBox
                title="Fox and Rabbit"
                position={[1, -2, 0]}
            >
                <ul>
                    <li><b>Navigate with arrow-keys!</b></li>
                    <li>Fox and rabbit modeled, textured, rigged and animated with Blender.</li>
                    <li>Gamelogic made with React Three Fiber and some Drei helpers.</li>
                    <li>Floor-image taken from free img-library: http://seamless-pixels.blogspot.de/2012/09/free-seamless-ground-textures.html.</li>
                    <li>Background: 360° panorama taken from http://photoflap.wordpress.com/2012/06/06/the-singing-sand-dune/.</li>
                </ul>
            </InfoBox>
        </>
    )
};
